import { RouteConfig } from '@/shared/lib';
import { matchPath } from 'react-router-dom';

export function isActive(route: RouteConfig, pathname: string) {
  // If navbar.path is specified, use only it for matching (exact match or with children)
  if (route.navbar?.path) {
    const navbarPath = route.navbar.path.startsWith('/') ? route.navbar.path : `/${route.navbar.path}`;
    return pathname === navbarPath || pathname.startsWith(`${navbarPath}/`);
  }

  // If no navbar.path, use matchPath with route.path for dynamic routes
  if (route.path) {
    return !!matchPath(route.path, pathname);
  }

  return false;
}

export function isActiveNested(route: RouteConfig, pathname: string): boolean {
  if (!route.children?.length) {
    return isActive(route, pathname);
  }
  return !!route.children.some((child) => isActiveNested(child, pathname));
}

export function calcGroupName(rootName: string, indexOrSubIndex?: number): string {
  return [rootName, indexOrSubIndex?.toString()].filter(Boolean).join('.');
}

/**
 * Разворачивает дерево вложенных групп в плоский список навигируемых пунктов.
 * Видимость пунктов не проверяет — отбирает их вызывающий по правилу видимости пункта меню.
 */
export function collectLeafRoutes(children: readonly RouteConfig[] = []): RouteConfig[] {
  return children.flatMap((child) => {
    if (child.children?.length) {
      return collectLeafRoutes(child.children);
    }
    return child.navbar ? [child] : [];
  });
}
